export default __webpack_public_path__ + "static/media/05.66cadbc6.jpg";